import { Box, Typography } from '@mui/material';

export function NotificationSearchNoResultsState() {
  return (
    <Box
      sx={{
        py: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        bgcolor: 'grey.50',
        borderRadius: 3,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Inga resultat hittades
      </Typography>
    </Box>
  );
}
